// El Tío Pacas — Data Layer
const WA = '51986447118';
const PROD_KEY = 'tpacas_products';
const CART_KEY = 'tpacas_cart';
const PROD_VER_KEY = 'tpacas_prod_ver';
const PROD_VERSION = 'v22';

const DEFAULT_PRODUCTS = [
  {
    id: 'p1', name: 'Pantalones Marquini', brand: 'Marquini', price: 19.5,
    category: 'pantalones', badge: 'NUEVO', emoji: '👖',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.27.24_PM.jpg?v=1787168876',
    images: [
      'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.27.24_PM.jpg?v=1787168876'
    ],
    description: 'Pantalones de marcas variadas. Modelos y tallas variados. El cliente no escoge modelo ni talla. Solo venta al por mayor en cajas.',
    sizesInfo: 'Tallas variadas',
    boxOptions: [
      { label: 'Caja x50', units: 50, pricePerUnit: 19.9, totalPrice: 995 },
      { label: 'Caja x100', units: 100, pricePerUnit: 19.5, totalPrice: 1950 }
    ],
    sizes: [], colors: [], available: true
  },
  {
    id: 'p2', name: 'Pantuflini', brand: 'Pantuflini', price: 7,
    category: 'pantuflas', badge: 'NUEVO', emoji: '🩴',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.28.35_PM.jpg?v=1787168888',
    images: [
      'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.28.35_PM.jpg?v=1787168888',
      'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.28.44_PM.jpg?v=1787168900'
    ],
    description: 'Pantuflas variadas. Modelos y tallas variados. El cliente no escoge modelo ni talla. Solo venta al por mayor en cajas.',
    sizesInfo: 'Tallas variadas',
    boxOptions: [
      { label: 'Caja x50', units: 50, pricePerUnit: 9, totalPrice: 450 },
      { label: 'Caja x100', units: 100, pricePerUnit: 7, totalPrice: 700 }
    ],
    sizes: [], colors: [], available: true
  },
  {
    id: 'p3', name: 'Casacas Impermeables', brand: 'Casacas Impermeables', price: 25,
    category: 'casacas', badge: 'NUEVO', emoji: '🧥',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.28.54_PM.jpg?v=1787168911',
    images: [
      'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.28.54_PM.jpg?v=1787168911',
      'https://cdn.shopify.com/s/files/1/0795/6948/5881/files/WhatsApp_Image_2026-08-19_at_2.44.18_PM.jpg?v=1787168923'
    ],
    description: 'Casacas impermeables de tallas y modelos variados. El código FRESJEAN incluye 10 casacas jean adicionales. El cliente no escoge modelo ni talla. Solo venta al por mayor en cajas.',
    sizesInfo: 'Tallas y modelos variados',
    boxOptions: [
      { label: 'YO FRESCO — Caja x50', units: 50, pricePerUnit: 25, totalPrice: 1250 },
      { label: 'FRESJEAN — Caja x60 (50 impermeables + 10 jean)', units: 60, pricePerUnit: 25, totalPrice: 1500 }
    ],
    sizes: [], colors: [], available: true
  }
];

const Store = {
  // ── Safe localStorage helpers ────────────────────────────────────────────
  _lsGet(key) { try { return localStorage.getItem(key); } catch(e) { return null; } },
  _lsSet(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch(e) {} },
  _lsRemove(key) { try { localStorage.removeItem(key); } catch(e) {} },
  _parse(raw, fallback) { try { return raw ? JSON.parse(raw) : fallback; } catch(e) { return fallback; } },

  // ── Products ─────────────────────────────────────────────────────────────
  getProducts(category) {
    const storedVer = this._parse(this._lsGet(PROD_VER_KEY), null);
    if (storedVer !== PROD_VERSION) {
      this._lsSet(PROD_KEY, DEFAULT_PRODUCTS);
      this._lsSet(PROD_VER_KEY, PROD_VERSION);
      this._lsRemove(CART_KEY);
      return category ? DEFAULT_PRODUCTS.filter(p => p.category === category) : [...DEFAULT_PRODUCTS];
    }
    const all = this._parse(this._lsGet(PROD_KEY), null);
    if (!Array.isArray(all) || !all.length) {
      this._lsSet(PROD_KEY, DEFAULT_PRODUCTS);
      return category ? DEFAULT_PRODUCTS.filter(p => p.category === category) : [...DEFAULT_PRODUCTS];
    }
    return category ? all.filter(p => p.category === category) : all;
  },
  getProduct(id) { return this.getProducts().find(p => p.id === id) || null; },

  // ── Cart ─────────────────────────────────────────────────────────────────
  getCart() {
    const raw = this._parse(this._lsGet(CART_KEY), []);
    if (!Array.isArray(raw)) return [];
    return raw.filter(item => {
      if (!item || typeof item !== 'object') return false;
      if (!item.key || !item.productId || !item.name || !item.brand) return false;
      const qty = Number(item.qty);
      if (!Number.isFinite(qty) || qty < 1 || qty > 500) return false;
      const price = Number(item.price);
      if (!Number.isFinite(price) || price <= 0 || price > 999999) return false;
      // Validate price against the real product catalog
      const product = DEFAULT_PRODUCTS.find(p => p.id === item.productId);
      if (!product) return false;
      if (product.boxOptions && product.boxOptions.length && item.boxLabel) {
        const validBox = product.boxOptions.find(b => b.label === item.boxLabel);
        if (!validBox || validBox.totalPrice !== price) return false;
      }
      return true;
    });
  },
  _saveCart(cart) { this._lsSet(CART_KEY, cart); },
  cartCount() { return this.getCart().reduce((s, i) => s + i.qty, 0); },
  cartTotal() { return this.getCart().reduce((s, i) => s + i.price * i.qty, 0); },
  addToCart(productId, boxOption) {
    const p = this.getProduct(productId);
    if (!p) return;
    // Always resolve price from the catalog, never from user-controlled input
    const resolvedBox = boxOption && p.boxOptions
      ? p.boxOptions.find(b => b.label === boxOption.label) || null
      : null;
    const price = resolvedBox ? resolvedBox.totalPrice : p.price;
    const cart = this.getCart();
    const key = productId + '_' + (resolvedBox ? resolvedBox.label : 'default');
    const ex = cart.find(i => i.key === key);
    if (ex) { ex.qty = Math.min(ex.qty + 1, 500); }
    else cart.push({ key, productId, name: p.name, brand: p.brand, price,
      boxLabel: resolvedBox ? resolvedBox.label : null,
      units: resolvedBox ? resolvedBox.units : null,
      pricePerUnit: resolvedBox ? resolvedBox.pricePerUnit : null,
      size: null, color: null, qty: 1 });
    this._saveCart(cart);
  },
  removeFromCart(key) { this._saveCart(this.getCart().filter(i => i.key !== key)); },
  updateQty(key, qty) {
    const safeQty = Math.max(0, Math.min(500, Math.floor(Number(qty))));
    if (safeQty <= 0) return this.removeFromCart(key);
    const cart = this.getCart();
    const item = cart.find(i => i.key === key);
    if (item) { item.qty = safeQty; this._saveCart(cart); }
  },
  clearCart() { this._saveCart([]); },
  buildWAMsg() {
    const cart = this.getCart();
    if (!cart.length) return '';
    let msg = '¡Hola! Quiero hacer este pedido:\n\n';
    // Re-validate prices from catalog before building the message
    cart.forEach(i => {
      const product = DEFAULT_PRODUCTS.find(p => p.id === i.productId);
      const box = product && product.boxOptions && i.boxLabel
        ? product.boxOptions.find(b => b.label === i.boxLabel) : null;
      const price = box ? box.totalPrice : (product ? product.price : i.price);
      const ppu = box ? box.pricePerUnit : null;
      msg += `• ${i.brand} ${i.name}`;
      if (i.boxLabel) msg += ` (${i.boxLabel}${ppu != null ? ' — S/ ' + ppu.toFixed(2) + '/u' : ''})`;
      msg += ` × ${i.qty} caja${i.qty > 1 ? 's' : ''} = S/ ${(price * i.qty).toFixed(2)}\n`;
    });
    msg += `\n💰 TOTAL: S/ ${this.cartTotal().toFixed(2)}\n\n¿Tienen disponibilidad?`;
    return `https://wa.me/${WA}?text=${encodeURIComponent(msg)}`;
  },
};
